import React, { useState } from "react";
import axios from "axios";
import "./style.css";
import imageSrc from "../images/cards-images/Strawberry.png";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";

const StrawberryPrediction = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [prediction, setPrediction] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("model_name", "strawberry");
    formData.append("file", selectedFile);

    setLoading(true);

    try {
      const response = await axios.post(
        "https://api.techshoor.com/predict/strawberry",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setPrediction(response.data);
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };

  return (
    <div>
      <head>
        {/* Additional code */}
        <link rel="stylesheet" href="./path/to/your/custom.css" />
      </head>
      <body>
        <Sidebar />

        <div id="content" className="single-card-container">
          <div className="single-card">
            <img className="single-card-img" src={imageSrc} alt="Card" />

            <h2 className="single-card-title">Strawberry</h2>
            <h2 className="single-card-title">اسٹرابیری</h2>
            <form onSubmit={handleSubmit}>
              <div className="single-input-group">
                <input
                  type="file"
                  id="single-image-input"
                  onChange={handleFileChange}
                />
                <label
                  htmlFor="single-image-input"
                  className="custom-file-upload"
                >
                  Upload Image
                </label>
              </div>
              <button
                type="submit"
                className="signle-btn-submit"
                disabled={!selectedFile || loading}
              >
                {loading ? "Predicting..." : "Predict"}
              </button>
            </form>
          </div>

          {loading && (
            <div className="single-output-card">
              <h1 className="single-output-title">Processing...</h1>
            </div>
          )}

          {prediction && (
            <div className="single-output-card">
              <h2 className="single-output-title">Prediction پیشن گوئی :</h2>

              <h3>Class:</h3>
              <p>{prediction.class}</p>
              <h3>Confidence:</h3>
              <p className="prediction-value">{prediction.confidence}</p>
              <h3>Recommendation:</h3>
              <p className="prediction-value">{prediction.recommendation}</p>
            </div>
          )}
          {/* Footer */}
          <Footer />
        </div>
      </body>
    </div>
  );
};

export default StrawberryPrediction;
